/* eslint-disable */
import { fetchUtils } from 'ra-core'
import simpleRestProvider from 'ra-data-simple-rest'
import {
  CreateParams, DataProvider,
  GetListParams,
  UpdateParams
} from 'react-admin'
import { debug } from '../test'
import authToken from '../utils/authToken'
import { getEnvVariable } from '../utils/getEnvVariable'

export const httpClient = (url: string, options: RequestInit = {}): Promise<{
  status: number;
  headers: Headers;
  body: string;
  json: any;
}> => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' })
    options.headers.set('accept-language', 'nl')
  }

  const user = {
    authenticated: true,
    token: authToken.getToken() || '',
  }

  if (!user.token || user.token === '') return Promise.reject({ status: 412 })

  return fetchUtils.fetchJson(url, { ...options, user })
}

export const getUrl = (): string => getEnvVariable('REACT_APP_SERVER_URL', '')

debug && console.log({ getUrl: getUrl() })
export const getJson = async <T,>(url: string, options?: RequestInit): Promise<T> => {
  const response = await httpClient(url, options)
  return response.json as T
}

export const putJson = async <T,>(url: string, body: unknown): Promise<T> => {
  const response = await httpClient(url, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'accept-language': 'nl',
    }),
  })
  return response.json as T
}

const dataProvider: DataProvider = simpleRestProvider(getUrl(), httpClient)

export const xxllncDataProvider: DataProvider = {
  ...dataProvider,
  get: async (resource: string) => httpClient(`${getUrl()}/${resource}`, {
    method: 'GET',
  }).then(({ json }) => ({ data: json })),
  getList: (resource: string, params: GetListParams) => {
    console.log('getList called successfully', { resource, params, url: getUrl() })
    return dataProvider.getList(resource, params)
  },
  create: (resource: string, params: CreateParams) => {
    console.log('create called successfully', { resource, params })
    if (!params.data.icon) {
      return dataProvider.create(resource, params)
    }
    return dataProvider.create(resource, params)
  },
  update: (resource: string, params: UpdateParams) => {
    console.log('Update called successfully', { resource, params })
    return dataProvider.update(resource, params)
  },
}
